/**
 * Switch the "next" button to instead be the "submit" button.
 */
function updateLastStepSubmitButton() {
	const nextStepButton = this.currentStepElement.querySelector('.js-quote-step-next');
	const nextStepButtonLabel = nextStepButton.querySelector('.ladda-label');

	console.log('Last step! Switching "Next" button to a submit button.');
	nextStepButton.dataset.submit = 'true';
	nextStepButtonLabel.textContent = 'Submit';
}

export {
	updateLastStepSubmitButton
}